var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhotoIsVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.378 4.98532L10.6303 2.95059C10.2278 2.7781 9.77221 2.7781 9.36973 2.95059L4.62202 4.98532C3.96663 5.2662 3.57621 5.94687 3.66465 6.65441L4.11097 10.225C4.31854 11.8855 5.14917 13.4052 6.43478 14.4766L8.97571 16.594C9.56906 17.0885 10.4309 17.0885 11.0243 16.594L13.5652 14.4766C14.8508 13.4052 15.6815 11.8855 15.889 10.225L16.3354 6.65441C16.4238 5.94687 16.0334 5.2662 15.378 4.98532Z",
    fill: "#15DC4D",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10L9.56873 12.0687C9.79184 12.2918 10.1633 12.2551 10.3383 11.9925L13.3333 7.5",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhotoIsVerified);
export default __webpack_public_path__ + "static/media/icon-photo-is-verified.1593c8a02c382e5d138d341ddc9a8ce5.svg";
export { ForwardRef as ReactComponent };